<section class="case-list-item">
    <section class="title-section">
        <h3>
            <a ng-click="openDocument($event)" ng-bind-html="item.Title|cHighlight:highlight"></a>
        </h3>
    </section>
    <section class="menu-section">
        <a class="action" ng-class="{isFavorite: workflow.IsFavorite}" ng-click="onFavoritesClick(workflow, $event)" ng-attr-title="{{ 'workflowList.favorite'|translate }}">
            <i class="fa fa-star-o" ng-if="!workflow.IsFavorite"></i>
            <i class="fa fa-star isFavorite" ng-if="workflow.IsFavorite"></i>
        </a>
        <a class="action" ng-click="viewDetails($event)" ng-attr-title="{{ 'workflowList.details'|translate }}"><i class="fa fa-info"></i></a>
    </section>
    <p ng-bind-html="(item.snippet ? item.snippet + '...' : item.snippet)|cHighlight:highlight" class="description">
    </p>
    <c-property-list properties="item.itemProperties" highlight="highlight"></c-property-list>
    <div ng-if="showDeadline()" class="deadline">{{'workflowList.deadline'|translate}} <span ng-class="{ 'deadline-exceeded': diffDays<0 }">{{deadline|cDate}}</span> {{daysLeft}}</div>
</section>